import type { MouseEvent } from "react";

type HashScrollBehavior = "auto" | "instant" | "smooth";

export function scrollToHash(hash: string, behavior: HashScrollBehavior = "smooth") {
  const id = hash.startsWith("#") ? hash.slice(1) : hash;
  const target = document.getElementById(id);
  if (!target) return false;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  target.scrollIntoView({
    behavior: prefersReducedMotion ? "auto" : behavior,
    block: "start",
  });
  return true;
}

export function handleHashClick(hash: string) {
  return (event: MouseEvent<HTMLElement>) => {
    if (!hash.startsWith("#")) return;
    event.preventDefault();
    scrollToHash(hash);
    window.history.replaceState(null, "", hash);
  };
}
